import React, { useState } from "react";
import { TreeItem, TreeItemLayout, Button, Label, Badge } from "@fluentui/react-components";
import VisitConceptStatusIcon from "./VisitConceptStatusIcon";
import VisitConceptLeafModal from "./VisitConceptLeafModal";

// styles 
import "./VisitConceptTreeLeaf.css"; // Assuming you have a CSS file for styles
import { ImCoinDollar } from "react-icons/im";
import { Settings20Regular } from "@fluentui/react-icons";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducers";
import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";
import { useTranslation } from 'react-i18next';

interface VisitConceptTreeLeafProps {
  ContractId: number; // Assuming ContractId is needed for the modal
  formName?: string;
  itemNumber?: number;
  label: string;
  value?: string | number;
  realized?: boolean;
  isPayable: boolean;
  isProcedure: boolean;
  type?: string;
}

const VisitConceptTreeLeaf: React.FC<VisitConceptTreeLeafProps> = ({ ContractId, formName, itemNumber, label, value, realized, isPayable, isProcedure, type }) => {
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();

  const ConceptRelationship = useSelector((state: AppState) => state.ContractConceptRelationship?.list); // Accessing the ConceptRelationships from the Redux store

  // Fallback label when the concept has no description
  const displayedLabel = (label && label.trim().length > 0)
    ? label
    : t('visitConcepts.labels.realized', 'Realized');

  return (
    <TreeItem itemType="leaf">
      <div
        className={`visit-concept-tree-leaf-label ${GetIfConceptIsPayable(ConceptRelationship, label) ? 'payable-leaf' : ''}`}
        style={{ position: 'relative', width: '100%' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <TreeItemLayout
          className={type === 'PayableField' ? 'payable-field' : 'normal-field'}
          // Si usas iconBefore o iconAfter, asegúrate de pasar solo ReactNode válido o undefined, nunca {}
          // Ejemplo seguro:
          iconBefore={realized !== undefined ? <VisitConceptStatusIcon realized={realized} /> : undefined}
          iconAfter={type === 'PayableField' ? <ImCoinDollar /> : undefined}
        >
          <span style={{ display: 'flex', alignItems: 'flex-start', gap: 3 }}>
            {displayedLabel}{value !== undefined ? `: ${value}` : null}
            {/* {GetIfConceptIsPayable(ConceptRelationship, label) ? <ImCoinDollar title={t('visitConcepts.labels.payableField')} style={{ fontSize: '20px', color: 'red' }} /> : null} */}
            {GetIfConceptIsPayable(ConceptRelationship, label) && <Badge>Facturable</Badge>}  
          </span>
        </TreeItemLayout>
        <span
          className="visit-concept-tree-leaf-float-btn"
          style={{
            opacity: hovered ? 1 : 0,
            pointerEvents: hovered ? 'auto' : 'none',
          }}
        >
          <VisitConceptLeafModal
            ContractId={ContractId} // Pass the ContractId prop
            formName={formName}
            itemNumber={itemNumber}
            label={displayedLabel}
            value={value}
            realized={realized}
            triggerAs={<Button size="small" icon={<Settings20Regular />} appearance="secondary" />}
          />
        </span>
      </div>
    </TreeItem>
  );
};

const GetIfConceptIsPayable = (concepts: ContractConceptRelationship[] | undefined, currentFormConcept: string): boolean => {
  return concepts ? concepts.some(concept => concept?.formConcept.toUpperCase() === currentFormConcept?.toUpperCase() && concept.isPayable) : false;
};

const GetIfConceptIsProcedure = (concepts: ContractConceptRelationship[] | undefined, currentFormConcept: string): boolean => {
  return concepts ? concepts.some(concept => concept?.formConcept.toUpperCase() === currentFormConcept?.toUpperCase() && concept.isProcedure) : false;
};

export default VisitConceptTreeLeaf;
